import React, { Fragment } from 'react'

import { Box, Flex, InputGroup } from '@clear/design-system'
import { useForm } from 'react-hook-form'
import { Form, StepSubTitle } from '@components/layout/Form'
import { yupResolver } from '@hookform/resolvers/yup'
import PageContent from './layout/PageContent'
import { ContinueButton } from './FormButtons'
import { authSchemaWithoutTerms } from '@validators/schema/enroll/authSchema'

interface SelectVerificationMethodFormProps {
  formData?: {
    email?: string
    phoneNumber?: string
  }
  onSubmitData: (formData) => void
}

const SelectVerificationMethodForm: React.FC<SelectVerificationMethodFormProps> =
  ({ onSubmitData }) => {
    const { register, handleSubmit, formState } = useForm<any>({
      resolver: yupResolver(authSchemaWithoutTerms),
      mode: 'onChange',
      defaultValues: {
        countryCode: '+1',
      },
    })
    const { errors } = formState

    async function onSubmit(formData: any) {
      onSubmitData(formData)
    }

    return (
      <PageContent>
        <Box
          sx={{
            width: '40%',
            marginLeft: 'auto',
            marginRight: 'auto',
            border: '1px solid #999',
            borderRadius: '8px',
            padding: '24px 20px',
          }}
        >
          <Fragment>
            <Box
              className="pb-4 px-4"
              as="img"
              minWidth={0}
              src="/tsa-pre-logo.svg"
              alt="TSA pre-check with CLEAR logo"
            />

            <StepSubTitle>
              Select one or two methods on which you want to receive OTP code
              for verification
            </StepSubTitle>

            <StepSubTitle
              color="brandDarkBlue"
              fontFamily="Inter-SemiBold"
              fontSize="14px"
            >
              Please Use Your Email and/or Phone Number
            </StepSubTitle>

            <Form onSubmit={handleSubmit(onSubmit)}>
              <InputGroup
                data-cy="email"
                placeholder={'Email'}
                {...register('email')}
                error={errors.email?.message}
                containerProps={{ padding: 0 }}
              />

              <Flex flexDirection="row">
                <InputGroup
                  data-cy={'countryCode'}
                  name="countryCode"
                  disabled
                  value="+1"
                  containerProps={{
                    padding: 0,
                    width: '20%',
                  }}
                />

                <InputGroup
                  data-cy="phoneNumber"
                  placeholder={'Phone number'}
                  {...register('phoneNumber')}
                  error={errors.phoneNumber?.message}
                  containerProps={{
                    padding: 0,
                    width: '90%',
                  }}
                />
              </Flex>

              <ContinueButton marginTop="15px" type="submit" />
            </Form>
          </Fragment>
        </Box>
      </PageContent>
    )
  }

export default SelectVerificationMethodForm
